// extracted by mini-css-extract-plugin
module.exports = {"container":"Page_container__1axJE","childrenContainer":"Page_childrenContainer__12V5O","noSpacingBottom":"Page_noSpacingBottom__3f98M"};